import React, {useEffect, useState} from 'react'
import Dialog from 'components/Dialog';
import Tr from 'translations/Translations';
import Loading from "components/Loading";
import DemandService from "services/DemandService";
import PropTypes from 'prop-types';
import BoldTypography from "../../BoldTypography";
import Link from "@material-ui/core/Link";
import {Typography} from "@material-ui/core";
import SingleButton from "../components/SingleButton";


function DemandRelatedObjects(
    {
        label,
        rels
    }) {


    return (
        <>
            <BoldTypography>{label}</BoldTypography>
            {
                rels.map((x, i) => {
                    if (!!x.url)
                        return (<Typography key={i} variant="body1"><Link key={i} target="_blank" href={x.url}>{x.name}</Link></Typography>)
                    else
                        return (<Typography key={i} variant="body1">{x.name}</Typography>)
                })
            }
            <br/>
        </>
    )
}


function DemandRelatedObjectsPopup(
    {
        relatedObjectServiceFunction = DemandService.getRelatedObjects,
        demandId,
        onClose
    }) {

    const [rel, setRel] = useState(null);

    useEffect(() => {
        relatedObjectServiceFunction(demandId).then((resp) => setRel(resp));
    }, [demandId, relatedObjectServiceFunction])


    return (
        <>
            <Dialog
                title={Tr('related_objects')}
                open={true}
                maxWidth='sm'
                onClose={onClose}
                dialogActions={<SingleButton
                    justify='flex-end'
                    label={Tr('close')}
                    onClick={onClose}
                />}
            >
                {!rel ?
                    <Loading/>
                    :
                    <>
                        {!!rel.planItems && <DemandRelatedObjects label={Tr("plan_items")} rels={rel.planItems}/>}
                        {!!rel.purchaseRequests && <DemandRelatedObjects label={Tr("purchase_requests")} rels={rel.purchaseRequests}/>}
                        {!!rel.purchasingGroups && <DemandRelatedObjects label={Tr("purchase_groups")} rels={rel.purchasingGroups}/>}
                        {!!rel.demands && <DemandRelatedObjects label={Tr("procedures")} rels={rel.demands}/>}
                    </>
                }
            </Dialog>
        </>
    )
}


DemandRelatedObjectsPopup.propTypes = {
    demandId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    onClose: PropTypes.func.isRequired,
}

export default DemandRelatedObjectsPopup;